import { createConsumer } from "@rails/actioncable";

export const cable = (chat_token?: string) => {
  const cableURL = chat_token ? `websocket?chat_token=${chat_token}` : "websocket";

  return createConsumer(`${process.env.REACT_APP_API_ENDPOINT}/${cableURL}`);
};
